<!--
@Create By Tim For 19/08/23
@培训需求容器组件
-->
<template>
  <div class="DemandContainer">
    <Demand />
  </div>
</template>

<script>
import Demand from '@/components/Demand/Demand'
export default {
  name: 'DemandContainer',
  data() {
    return {

    }
  },

  components: {
    Demand
  },
  created() { },

  mounted() { },

  methods: {},
}
</script>

<style scoped>
.DemandContainer {
  width: 1440px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/container/DemandContainer.vue